<template>
  <div>
    <Header>Routing Management</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mx-auto my-4 flex flex-col gap-4">
        <RoutePull
        />
        <StudentsDisplay
          v-if="showListStudentsPendingChanges"
        />
        <TransferDates
        />
        <PendingNotifications
        />
        <SyncStep
        />
        <MultipleScheduleRequestsAggregator
        />
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Main from '../components/Main.vue'
import Header from '../components/Header.vue'

import RoutePull from '../components/routingManagement/routePulling/RoutePull.vue'
import StudentsDisplay from '../components/routingManagement/StudentsDisplay.vue'
import TransferDates from '../components/routingManagement/routePulling/TransferDates.vue'
import PendingNotifications from '../components/routingManagement/PendingNotifications.vue'

import SyncStep from '../components/routingManagement/SyncStep/SyncStep.vue'
import MultipleScheduleRequestsAggregator from '../components/routingManagement/StudentRequests/MultipleRequestsAggregator.vue'

import user from '../services/user/user'
import partitions from '../services/partitions.js'

export default {
  components: {
    Main,
    Header,
    RoutePull,
    StudentsDisplay,
    TransferDates,
    PendingNotifications,
    SyncStep,
    MultipleScheduleRequestsAggregator,
  },
  data() {
    return {
      showListStudentsPendingChanges: false,
      studentsPendingChanges: [
        { firstName: 'utrsfdg' },
        { firstName: 'kgjgjgg;kjgkj kjkj' },
        { firstName: 'hfdshdf urtshdf' },
      ],

      partitions: [],
      selectedPartitions: [],
    }
  },
  methods: {
    toStudentList() {
      this.$router.push({
        name: 'StudentList'
      })
    },
    startRoutePull() {
      console.log('message server to start Route Pull')
    },
    toggleSelectedPartition(index) {
      this.$set(this.selectedPartitions, index, !this.selectedPartitions[index])
    }
  },
  async mounted() {
    this.user = await user.get()
    if (!this.user.can('view_routing_management')) {
      this.$router.push({
        path: '/'
      })
    }

    await partitions.getPartitionFromServer()
    this.partitions = await partitions.getPartition()
    this.$set(this, 'selectedPartitions', this.partitions.map(() => false))
  },
}
</script>
